export const tabContainerStyle = {
    background: '#4b545f',
    tabType: 'scrollable',
    marginTop: 200,
    left: 0,
    color: '#fff'
}


// WEBPACK FOOTER //
// ./src/tabs/styles/desktop.js